import GeoJSON from 'ol/format/GeoJSON';
// import { navigationLayers } from './layers/admin';

export const findDataForCode = (data, code) =>
{
    if (data==undefined)
    {
        return {code, value: "Data hasn't loaded!"};
    }
    return data.find(item => item.code === code);
};

export const dataCache = {
    state: {},
    district: {},
    municipality: {},
}

export const getDataFromCache = (division, in_field, code) =>
{
    const field = in_field || dataCache.lastField;
    console.assert(Object.keys(dataCache).includes(division), `Invalid division ${division}`)
    console.assert(Object.keys(dataCache[division]).includes(field), `Invalid field ${field}`)
    console.assert(dataCache[division][field], `Data uninitialized!`)
    
    return findDataForCode(dataCache[division][field], code);
}

export async function fetchData(division, dataField)
{
   const urlOrigin = process.env.VUE_APP_API_URL_ORIGIN;
   const dataUrlPrefix = `${urlOrigin}maphelper/api/`;
   let url;
   if (division=='state')
   {
      url = dataUrlPrefix + 'state-data' + '?field=' + dataField;
   }
   else if (division=='district')
   {
      url = dataUrlPrefix + 'district-data' + '?field=' + dataField;
   }
   else if (division=='municipality')
   {
      url = dataUrlPrefix + 'municipality-data' + '?field=' + dataField;
   }
   else
   {
      throw Error("Unknown division: " + division);
   }
   const res = await fetch(url);
   return await res.json()
}

export const setLastField = dataField =>
{
    dataCache.lastField = dataField;
}

export const fetchAllDivisionData = async dataField =>
{
    if (dataCache.state[dataField] && dataCache.district[dataField] && dataCache.municipality[dataField])
    {
        return {
            stateData: dataCache.state[dataField],
            districtData: dataCache.district[dataField],
            municipalityData: dataCache.municipality[dataField],
        }
    }
    const [stateData, districtData, municipalityData] = await Promise.all([
        fetchData('state', dataField),
        fetchData('district', dataField),
        fetchData('municipality', dataField),
    ]);

    dataCache.state[dataField] = stateData.data;
    dataCache.district[dataField] = districtData.data;
    dataCache.municipality[dataField] = municipalityData.data;

    return {stateData: stateData.data, districtData: districtData.data,  municipalityData: municipalityData.data};
};

class GeoJSONAPI
{
    constructor()
    {
        const urlOrigin = process.env.VUE_APP_API_URL_ORIGIN;
        this.stateUrl = `/state.geojson`;
        this.districtUrl = `${urlOrigin}maphelper/api/districts/`
        this.muniUrl = `${urlOrigin}maphelper/api/municipalities/`
        this.parser = new GeoJSON();
    }

    async getFeatures(fullUrl)
    {
        const res = await fetch(fullUrl);
        const geojson = await res.json();
        return this.parser.readFeatures(geojson);
    }

    async getStates()
    {
        return await this.getFeatures(this.stateUrl);
    }

    async getDistricts(scode)
    {
        return await this.getFeatures(this.districtUrl + scode);
    }

    async getMunicipalities(dcode)
    {
        return await this.getFeatures(this.muniUrl + dcode);
    }
}

const api = new GeoJSONAPI();
let STATE_FEATURES_CACHE;
let DISTRICT_FEATURES_CACHE;
let MUNICIPALITY_FEATURES_CACHE;

export const getStateFeatures = async () =>
{
    if(!STATE_FEATURES_CACHE)
    {
        STATE_FEATURES_CACHE = await api.getStates();
    }
    return STATE_FEATURES_CACHE;
};

export const getDistrictFeatures = async () =>
{
    if (!DISTRICT_FEATURES_CACHE)
    {
        DISTRICT_FEATURES_CACHE = await api.getDistricts(0);
    }
    return DISTRICT_FEATURES_CACHE;
};

export const getMunicipalityFeatures = async () =>
{
    if (!MUNICIPALITY_FEATURES_CACHE)
    {
        MUNICIPALITY_FEATURES_CACHE = await api.getMunicipalities(0);
    }
    return MUNICIPALITY_FEATURES_CACHE;
};

// fetching early so it loads a bit faster
// getStateFeatures();
getDistrictFeatures();
// getMunicipalityFeatures();